<template>
  <div class="city-dorms section">
    <div class="city-dorms-bg">
      <img src="@/assets/img/shapes/shape-9.svg" alt="holywood skyline" class="shape-9">
      <img src="@/assets/img/shapes/shape-10.svg" alt="holywood skyline" class="shape-10">
    </div>
    <container>
      <div class="city-dorms__wrp">
        <div class="city-dorms__cnt">
          <img src="@/assets/img/building.svg" alt="" class="city-dorms__icon">
          <div class="city-dorms__title color-white">
            <span class="d-block color-purple">
              Movie Lists
            </span>
            According to Genres
          </div>
          <div class="city-dorms__txt text color-white cropDesktop" v-if="settings">
            <!-- {{ settings.setting.city_section_spot }} -->
            Are you looking for a spesific studio movie ?
          </div>

          <div class="city-dorms__txt text color-white cropMobile" v-if="settings">
            {{ settings.setting.city_section_spot | truncate(100)  }}
          </div>

          <div class="city-dorms-inf">
            <div class="city-dorms-inf__title" v-if="settings">
              <strong>{{ settings.dorms }}</strong>
              Active Movie
            </div>

            <v-link
              class="button--more color-purple"
              title="See All"
              icon="icon-arrow-long-right"
              icon-position="right"
              :to="{ name: 'CityList' }"
            />
          </div>
        </div>

        <div class="city-dorms-slider sliderMobile">
        <swiper :options="swiperOption">
          <swiper-slide
            v-for="city in cities"
            :key="city.id"
            class="featured-dorms__col">
            <CityCard
              :city="city"
            />
          </swiper-slide>
          <div class="swiper-paginations" style="text-align: center;" slot="pagination"></div>
        </swiper>
        </div>

        <div class="city-dorms-slider sliderDesktop">
          <CityCard
            v-for="(city, $index) in genres"
            :key="city.id"
            :class="{ premium : $index === 0 }"
            :city="city"
          />
        </div>
      </div>
    </container>
    <div class="city-dorms__bottom">
      <img src="@/assets/img/shapes/shape-4.svg" alt="" class="shape-4">
      <div class="city-dorms-ctr">
        <img src="@/assets/img/shapes/shape-5.svg" alt="" class="shape-5">
        <div class="shapes-6">
          <img src="@/assets/img/shapes/shape-6.svg" alt="" class="shape-6">
        </div>

        <div class="city-dorms-ctr__cnt">
          <img src="@/assets/img/pin-navy.svg" alt="" class="city-dorms-ctr__img">
          <router-link :to="{ name: 'Notice' }" class="city-dorms-ctr__btn">
            <div class="btn-txt">Ads for Movies</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CityCard from '@/components/CityCard'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'CityDorms',
  components: {
    CityCard
  },
  data () {
    return {
      genres: [
      {
      title: "Animation",
      backdrop_path: "/9DA9dxRE0fRlpl4amBmLCjQdZay.jpg",
      id: 286904,
      name: "Ultimate Avengers Collection",
      original_language: "en",
      original_name: "Ultimate Avengers Collection",
      overview: "When a nuclear missile was fired at Washington in 1945, Captain America managed to detonate it in the upper atmosphere. But then he fell miles into the icy depths of the North Atlantic, where he remained lost for over sixty years. But now, with the world facing the very same evil, Captain America must rise again as our last hope for survival.",
      poster_path: "/bOXJmKCHKtqJILiJ5womPDigEoc.jpg"
    },
    {
      adult: "Action",
      backdrop_path: null,
      id: 482721,
      name: "Alien Avengers Collection",
      original_language: "en",
      original_name: "Alien Avengers Collection",
      overview: "Alien Avengers (Welcome to Planet Earth) and Alien Avengers II (Aliens Among Us)",
      poster_path: null
    },
    {
      adult: "Horror",
      backdrop_path: "/zuW6fOiusv4X9nnW3paHGfXcSll.jpg",
      id: 86311,
      name: "The Avengers Collection",
      original_language: "en",
      original_name: "The Avengers Collection",
      overview: "A superhero film series produced by Marvel Studios based on the Marvel Comics superhero team of the same name, and part of the Marvel Cinematic Universe (MCU).  The series features an ensemble cast from the Marvel Cinematic Universe series films, as they join forces for the peacekeeping organization S.H.I.E.L.D. led by Nick Fury.",
      poster_path: "/bvjltR2nDuhf1NlnwCrgNwvHuIh.jpg"
    },
    {
      adult: "Drama",
      backdrop_path: "/tp0buiNBb6iFjlr34lCB9ardTEA.jpg",
      id: 522577,
      name: "Avengers Grimm Collection",
      original_language: "en",
      original_name: "Avengers Grimm Collection",
      overview: "Avengers Grimm is a 2015 American fantasy action adventure film written, co-edited, and directed by Jeremy M. Inman. The film, produced by B-movie film company The Asylum, stars Casper Van Dien, Lou Ferrigno, Kimo Leopoldo, Lauren Parkinson, Milynn Sarley, Marah Fairclough, Rileah Vanderbilt, and Elizabeth Peterson. Avengers Grimm received a direct sequel in 2018 through Avengers Grimm: Time Wars while also having gotten a loose spin-off through Sinister Squad in 2016.",
      poster_path: "/oqEp8zCTK7mTKeeEHCTCkT3pMLx.jpg"
    },
    {
      adult: "Thriller",
      backdrop_path: "/zh72eVJTD5EssStCsNHqELuh6uD.jpg",
      id: 531241,
      name: "Spider-Man (Avengers) Collection",
      original_language: "en",
      original_name: "Spider-Man (Avengers) Collection",
      overview: "A superhero film series based on the Marvel character Spider-Man, portrayed by Tom Holland. The series is centered on Peter Parker, an academically gifted but socially inept high school student who fights crime as Spider-Man, a member of The Avengers.",
      poster_path: "/nogV4th2P5QWYvQIMiWHj4CFLU9.jpg"
    }
    ],
      cities: [],
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 2,
        breakpoints: {
          576: {
            slidesPerView: 1,
            centeredSlides: false,
            slidesPerGroup: 1
          },
          320: {
            slidesPerView: 1
          }
        },
        pagination: {
          el: '.swiper-paginations',
          clickable: true
        }
      }
    }
  },
  methods: {
    getCities () {
      let self = this
      // axios.get('/site/home/cities?take=5')
      axios.get('/3/movie/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&page=1')
        .then(response => {
          self.cities = response.data.results
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['settings'])
  },
  created () {
    this.getCities()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/components/city-dorms";
</style>
